import {useMutation} from '@tanstack/react-query';

import {RQ_FORGOT_PASSWORD_API, RQ_RESET_PASSWORD_API, RQ_USER_LOGIN_API, RQ_USER_REGISTRATION_API} from './constants';
import {rqCreateRequest} from './rqHttpUtils';

export const RQUserLoginAPI = (options ={}) => {
  console.log('rq user login api', options);
  return useMutation({
    mutationKey: ['rq_login_user'],
    mutationFn: async formData => {
      if (!formData) {throw new Error('formData is undefined');}
      return rqCreateRequest(RQ_USER_LOGIN_API, formData);
    },
    ...options,
  });
};

export const RQUserRegistrationAPI = (options = {}) => {
  console.log('rq user register api', options);
  return useMutation({
    mutationKey: ['rq_register_user'],
    mutationFn: async formData => {
      console.log('Using API config:', RQ_USER_LOGIN_API);
      if (!formData) {throw new Error('formData is undefined');}
      return rqCreateRequest(RQ_USER_REGISTRATION_API, formData);
    },
    ...options,
  });
};

export const RQForgotPasswordAPI = () => {
  return useMutation({
    mutationFn: async ({email}) => {

      const response = await rqCreateRequest(
        RQ_FORGOT_PASSWORD_API,
        null,
        null,
        null,
        null,
        'application/json',
        'application/json',
        {email},
      );

      return response;
    },
  });
};

export const RQResetPasswordAPI = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_reset_password'],
    mutationFn: async ({formData}) => {
      return rqCreateRequest(
        RQ_RESET_PASSWORD_API,
        formData,
        null,
        null,
      );
    },
    ...options,
  });
};
